// extracted by mini-css-extract-plugin
module.exports = {"kidsWrap":"Kids8695bbdc5e785a3316e68c652d39f126","pageWrapper":"Kids22a8434c7d5f3e61c7516553d15c06e0","body":"Kidsc012084f6b8b773082be3b307b889490"};